"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var userInfo_1 = require("../../model/userInfo");
var service_1 = require("../../../library/base/service");
var UpdateInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UpdateInfo, _super);
    function UpdateInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '更新个人信息接口';
        _this.code = '101104';
        _this.desc = '更新个人信息接口';
        _this.requestParams = new userInfo_1.UpdateInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return UpdateInfo;
}(service_1.BaseService));
exports.UpdateInfo = UpdateInfo;
//# sourceMappingURL=updateInfo.js.map